export const FEATURES_CONSTANT = {
    HANDYMAN_AND_WHOLESALE_CLUB: 'handyManAndWholesaleClub',
    SP_COMPETE_EXPERIMENT_V2: 'isSpCompeteExperimentV2Enabled',
    APPLIANCE_TAG_UPLOAD: 'isApplianceTagScanEnabled',
    MOENANDH4H: 'isMoenAndH4HEnabled',
    CROSS_SELL_V2: 'isCrossSellV2Enabled',
    CROSS_SELL_CARD_V2: 'isCrossSellCardV2Enabled',
    MY_PLAN_STORY: 'myPlanStoryEnabled',
}
